import { render } from "./CustomInput.vue?vue&type=template&id=4275605e&scoped=true"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"

import "./CustomInput.vue?vue&type=style&index=0&id=4275605e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4275605e"]])

export default __exports__